import React from "react";
import "./about.scss";
import logo from "../../media/logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faHouseChimney,
} from "@fortawesome/free-solid-svg-icons";

const about = () => {
  const buttonwaabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const buttonwabrosur = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(brosur)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div id="about" className="container-about">
      {/* <div className="logo-about">
        <img className="gambar-logo" src={logo} alt="logo summarecon bekasi" />
      </div> */}
      <div className="container1">
        <div className="brosur">
          <div className="icon">
            <FontAwesomeIcon color="#DFA527" size="2x" icon={faHouseChimney} />
          </div>
          <div className="deskripsi">
            <div className="p1">Tipe Properti</div>
            <div className="p2"> Rumah Ready dan Indent</div>
          </div>
        </div>
        {/* <div className="button">
          <button onClick={buttonwabrosur} className="brosure">
            <div>Brosure</div>
          </button>
        </div> */}
        <div className="pembayaran">
          <div className="icon">
            <FontAwesomeIcon color="#DFA527" size="2x" icon={faCreditCard} />
          </div>
          <div className="deskripsi">
            <div className="p1">Jenis Pembayaran</div>
            <div className="p2"> Cash, Cash Bertahap dan KPR </div>
          </div>
        </div>
        <div className="button1">
          <button onClick={buttonwaabout} className="whatsap-pembayaran">
            <div>Whatsapp</div>
          </button>
        </div>
      </div>
      <div className="container-deskripsi">
        <div className="deskripsi-about">
          <div className="judul-deskripsi">
            <h1>Summarecon Bekasi</h1>
          </div>
          <div className="deskripsi">
            Summarecon Bekasi adalah sebuah kota modern yang dilengkapi dengan
            berbagai fasilitas modern berskala kota. Summarecon Bekasi terletak
            di Bekasi, Jawa Barat, Indonesia, dan merupakan bagian dari wilayah
            metropolitan Jakarta yang lebih besar. Pengembangan Summarecon
            Bekasi memiliki luas tanah sekitar 240 hektar dan terbagi menjadi
            zona komersial dan zona residensial
          </div>
        </div>
      </div>
    </div>
  );
};

export default about;
